import { render, staticRenderFns } from "./PresenceEditor.vue?vue&type=template&id=1edd8a47&"
import script from "./PresenceEditor.vue?vue&type=script&lang=js&"
export * from "./PresenceEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports